import React from 'react';
import MindfullLogo from '@/components/MindfullLogo';

export const Footer = () => (
  <footer className="py-8 px-6 sm:px-10 lg:px-16 border-t border-border/30 bg-background">
    <div className="max-w-5xl mx-auto flex flex-col md:flex-row justify-between items-center gap-4">
      <MindfullLogo size="sm" />
      <div className="flex gap-6 text-sm text-muted-foreground">
        <a href="#" className="hover:text-foreground transition-colors">Privacy</a>
        <a href="#" className="hover:text-foreground transition-colors">Terms</a>
        <a href="#" className="hover:text-foreground transition-colors">Contact</a>
      </div>
      <p className="text-sm text-muted-foreground">
        © 2025 Mindfull
      </p>
    </div>
  </footer>
);
